(function () {
  function bindHoverVideo(mediaRoot) {
    if (mediaRoot.dataset.buffCardVideoBound === 'true') return;
    const card = mediaRoot.closest('.card--product');
    const video = mediaRoot.querySelector('video');
    if (!card || !video) return;

    mediaRoot.dataset.buffCardVideoBound = 'true';
    video.pause();
    video.currentTime = 0;

    const playBtn = card.querySelector('[data-buff-card-play]');

    const setPlayingUI = (isPlaying) => {
      card.classList.toggle('is-playing', isPlaying);
      if (!playBtn) return;
      playBtn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      playBtn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      const playIcon = playBtn.querySelector('.buff-card-play-btn__icon--play');
      const pauseIcon = playBtn.querySelector('.buff-card-play-btn__icon--pause');
      if (playIcon) playIcon.hidden = isPlaying;
      if (pauseIcon) pauseIcon.hidden = !isPlaying;
    };

    const playVideo = () => {
      video.play().catch(() => {});
      setPlayingUI(true);
    };

    const pauseVideo = () => {
      video.pause();
      video.currentTime = 0;
      setPlayingUI(false);
    };

    const togglePlay = (event) => {
      // Stop the parent product link from navigating
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      if (card.classList.contains('is-playing') && !video.paused) {
        pauseVideo();
      } else {
        playVideo();
      }
    };

    // Desktop/hover devices: play on hover/focus. Skip on touch so focus+click don't fight.
    if (window.matchMedia('(hover: hover)').matches) {
      card.addEventListener('mouseenter', playVideo);
      card.addEventListener('mouseleave', pauseVideo);
      card.addEventListener('focusin', playVideo);
      card.addEventListener('focusout', pauseVideo);
    }

    if (playBtn) {
      // pointerdown handles play/pause before the parent <a> navigates
      playBtn.addEventListener('pointerdown', togglePlay);
      // Suppress the follow-up click so we don't toggle twice or follow the link
      playBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      });
      playBtn.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          togglePlay(event);
        }
      });
    }
  }

  function initBuffCardHoverVideo(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-buff-card-hover-video]').forEach(bindHoverVideo);
  }

  // Expose for async-injected cards (e.g. product recommendations section)
  window.initBuffCardHoverVideo = initBuffCardHoverVideo;

  // Re-init Yotpo star widgets after AJAX-injected product cards (infinite scroll, recommendations)
  let yotpoInitTimer = null;

  function syncBuffYotpoCardCounts(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.buff-card-yotpo-rating').forEach((block) => {
      const countEl = block.querySelector('.buff-card-yotpo-rating__count');
      if (!countEl || countEl.textContent.trim()) return;

      const yotpoText = block.querySelector(
        '.yotpo-sr-bottom-line-text, .yotpo-sr-bottom-line-text--right-panel'
      );
      if (!yotpoText) return;

      const match = yotpoText.textContent.match(/\d+/);
      if (!match) return;

      const n = match[0];
      const linkReviews = block.getAttribute('data-buff-yotpo-link-reviews') === 'true';
      if (linkReviews) {
        const href =
          countEl.getAttribute('data-buff-yotpo-reviews-href') ||
          countEl.getAttribute('href') ||
          '';
        countEl.textContent = `(see ${n} review${n === '1' ? '' : 's'})`;
        if (href && countEl.tagName === 'A') countEl.setAttribute('href', href);
      } else {
        countEl.textContent = `(${n})`;
      }
      countEl.hidden = false;
    });
  }
  window.syncBuffYotpoCardCounts = syncBuffYotpoCardCounts;

  function initBuffYotpoCardRatings(root) {
    clearTimeout(yotpoInitTimer);
    yotpoInitTimer = setTimeout(function () {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      }
      // Yotpo injects count text asynchronously after initWidgets
      setTimeout(function () {
        syncBuffYotpoCardCounts(root);
      }, 400);
      setTimeout(function () {
        syncBuffYotpoCardCounts(root);
      }, 1200);
    }, 100);
  }
  window.initBuffYotpoCardRatings = initBuffYotpoCardRatings;

  document.addEventListener('DOMContentLoaded', function () {
    initBuffCardHoverVideo();
    initBuffYotpoCardRatings();
  });
  document.addEventListener('shopify:section:load', function (event) {
    initBuffCardHoverVideo(event.target);
    initBuffYotpoCardRatings();
  });

  // Catch cards injected after initial load (product recommendations fetch, etc.)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function (mutations) {
      let sawYotpo = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('[data-buff-card-hover-video]')) {
            bindHoverVideo(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('[data-buff-card-hover-video]').forEach(bindHoverVideo);
          }
          if (
            node.matches?.('.buff-card-yotpo-rating, .yotpo-widget-instance') ||
            node.querySelector?.('.buff-card-yotpo-rating')
          ) {
            sawYotpo = true;
          }
        }
      }
      if (sawYotpo) initBuffYotpoCardRatings(document);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
